/** Single source of truth for AI infrastructure tiers (landing + partner console). */

export const AI_TIERS = [
  {
    id: 1,
    key: "tier1",
    badge: "Starter",
    name: "Local Service AI Employees",
    shortName: "Tier 1",
    credits: 100,
    dialoguesMin: 50,
    dialoguesMax: 65,
    wholesale: 299,
    retailMin: 439,
    retailMax: 539,
    deployLabel: "Tier 1: $299/mo wholesale",
    profile:
      "Local contractors, boutiques, and regional service businesses with stable monthly ad spend.",
    capacity:
      "Optimized for standard after-hours interception and weekend safety-net automation.",
    creditsLabel: "100 AI Credits / mo (~50–65 full dialogues)",
    retailLabel: "$439 – $539 / month",
    wholesaleLabel: "Only $299 / month",
    profitLabel: "+$140 to $240+ / mo per client",
    systems:
      "Core 9s response protocol, Native CRM integration, Strict Policy Engine.",
  },
  {
    id: 2,
    key: "tier2",
    badge: "Growth",
    name: "Growth AI Employees",
    shortName: "Tier 2",
    credits: 350,
    dialoguesMin: 175,
    dialoguesMax: 236,
    wholesale: 399,
    retailMin: 599,
    retailMax: 699,
    deployLabel: "Tier 2: $399/mo wholesale",
    profile:
      "Growing service businesses with steady lead flow and daytime coverage needs.",
    capacity:
      "High-performance allocation for frequent qualification, scheduling, and quote workflows.",
    creditsLabel: "350 AI Credits / mo (~175–235 full dialogues, ~3.5× Tier 1)",
    retailLabel: "$599 – $699 / month",
    wholesaleLabel: "Only $399 / month",
    profitLabel: "+$200 to $300+ / mo per client",
    systems:
      "Priority CRM pipelines, Extended execution states, Weather Sentry & Advanced API allocation.",
  },
  {
    id: 3,
    key: "tier3",
    badge: "Scale",
    name: "Enterprise Scaling AI Employees",
    shortName: "Tier 3",
    credits: 1000,
    dialoguesMin: 500,
    dialoguesMax: 667,
    wholesale: 799,
    retailMin: 999,
    retailMax: 1199,
    deployLabel: "Tier 3: $799/mo wholesale",
    profile:
      "High-volume market leaders, franchise networks, and multi-location businesses scaling aggressive campaigns.",
    capacity:
      "Maximum concurrent leads, deep logging, multi-agent orchestration at scale.",
    creditsLabel: "1,000 AI Credits / mo (~500–665 full dialogues)",
    retailLabel: "$999 – $1199 / month",
    wholesaleLabel: "Only $799 / month",
    profitLabel: "+$200 to $400+ / mo per client",
    systems:
      "Full agent stack, priority routing, advanced quote & scheduling, dedicated pool headroom.",
  },
];

export const TIER_ROWS = [
  {
    label: "Client Business Profile",
    tier1: AI_TIERS[0].profile,
    tier2: AI_TIERS[1].profile,
    tier3: AI_TIERS[2].profile,
  },
  {
    label: "Infrastructure Capacity",
    tier1: AI_TIERS[0].capacity,
    tier2: AI_TIERS[1].capacity,
    tier3: AI_TIERS[2].capacity,
  },
  {
    label: "Included Monthly AI Credits",
    tier1: AI_TIERS[0].creditsLabel,
    tier2: AI_TIERS[1].creditsLabel,
    tier3: AI_TIERS[2].creditsLabel,
  },
  {
    label: "Recommended Retail Price",
    tier1: AI_TIERS[0].retailLabel,
    tier2: AI_TIERS[1].retailLabel,
    tier3: AI_TIERS[2].retailLabel,
  },
  {
    label: "Wholesale Infrastructure Cost",
    tier1: AI_TIERS[0].wholesaleLabel,
    tier2: AI_TIERS[1].wholesaleLabel,
    tier3: AI_TIERS[2].wholesaleLabel,
  },
  {
    label: "Your Net Agency Profit Matrix",
    tier1: AI_TIERS[0].profitLabel,
    tier2: AI_TIERS[1].profitLabel,
    tier3: AI_TIERS[2].profitLabel,
    highlight: true,
  },
  {
    label: "Core Systems Included",
    tier1: AI_TIERS[0].systems,
    tier2: AI_TIERS[1].systems,
    tier3: AI_TIERS[2].systems,
  },
];

export const getTierById = (id) => AI_TIERS.find((t) => t.id === Number(id));

export const WHOLESALE_RANGE = `$${AI_TIERS[0].wholesale}–$${AI_TIERS[2].wholesale}`;
export const RETAIL_RANGE = `$${AI_TIERS[0].retailMin}–$${AI_TIERS[2].retailMax}`;

export const WHOLESALE_PRICE_SUMMARY = AI_TIERS.map((t) => `$${t.wholesale}`).join(" / ");
